<template>
  <div class="diagnose-list">

      <diagnose-list-skeleton v-if="loading"></diagnose-list-skeleton>
      <div v-else>

          <div class="search">
              <van-search v-model="value" @click="$router.push({name:'search'})" @search="onSearch" @clear="onCancel" placeholder="搜一搜"></van-search>
          </div>

          <div class="tags">
              <van-tabs :swipeable="true" v-model="category_index" @click="changeCategory">
                  <van-tab :title-class="'course-list-category-title'" v-for="(item,index) in categories" :key="index" :title="item.name" ></van-tab>
              </van-tabs>
              <div class="clear"></div>
          </div>

          <div class="diagnose-list-section" v-if="list.length > 0">
              <van-row class="diagnose-list-section-box" @click="go_detail(item)" v-for="item in list" :key="item.id">
                  <div class="diagnose-list-section-left">
                      <van-image
                          fit="cover"
                          class="diagnose-list-section-left-img"
                          :src="item.cover_img"
                          width="100%"
                          height="100%"
                      />
                  </div>
                  <div class="diagnose-list-section-right">
                      <div class="diagnose-list-section-right-title">{{item.title}}</div>
                      <div class="diagnose-list-section-right-btn">去查看 <img src="/static/bytx/list_more_icon.svg" alt=""></div>
                  </div>
                  <div class="clear"></div>
                  <div class="diagnose-list-section-info">{{item.desc}}</div>
              </van-row>
          </div>
          <div class="van-list__finished-text" v-if="list.length > 6 && page === total_page">已到底部</div>
          <div v-else-if="list.length > 0 && total_page > page" class="finish-more" @click="fetch_more()">查看更多</div>
          <van-empty v-else-if="list.length === 0" description="" image="/static/img/pic_blank_content.svg" >
              <template slot="description">
                  <div style="text-align: center">博医同行持续更新中…</div>
                  <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                  <div style="text-align: center;margin-top: 24px">
                      <van-button color="#0FB7AD" round size="small" style="width: 120px" @click="$toHomePage">
                          返回首页
                      </van-button>
                  </div>
              </template>
          </van-empty>
      </div>

  </div>
</template>
<script>
    import Interface from "@/util/interface"
    import diagnoseListSkeleton from "@/skeleton/articleListSkeleton"
    export default {
        name: 'diagnose-list',
        components :{
            'diagnose-list-skeleton' : diagnoseListSkeleton
        },
        data() {
            return {
                value: "",
                active: "",
                category_id :0,
                category_child_id:0,
                category_index:0,
                banners: [],
                categories: [],
                categories_child:[],
                recommend:[],
                list:[],
                column:[],
                loading:true,
                page:1,
                pageSize:10,
                total_page:1,
            }
        },
        methods: {
            fetch(scene) {
                if (scene === 'category') {
                    Interface.getData('get', Interface.category,{type:11}).then((res) => {
                        this.categories = res.data.list
                        this.categories.unshift({name:"全部",id:0})
                        if(this.categories.length < 5){
                            for(let i=999;i<= (1007 - this.categories.length);i++){
                                this.categories.push({name:"",id:i})
                            }
                        }
                    })
                } else if (scene === 'diagnose') {
                    this.page = 1
                    let params = {
                        page:this.page,
                        pageSize:this.pageSize,
                        category_id : this.category_id,
                    }
                    if(this.value != ""){
                        params.category_id = 0
                        params.title = this.value
                    }
                    Interface.getData('get', Interface.diagnose.list,params).then((res) => {
                        if(res.data.list != null){
                            this.list = res.data.list
                            this.total_page = res.data.total_page
                        }else{
                            this.list = [];
                            this.total_page = 1
                        }
                        setTimeout(()=>{this.loading = false;},500)
                    })
                }
            },
            fetch_more(){
                this.page += 1
                let params = {
                    page : this.page,
                    pageSize:10,
                    category_id : this.category_id,
                }
                Interface.getData('get', Interface.clinic.list,params).then((res) => {
                    this.list.push(...res.data.list)
                    this.total_page = res.data.total_page
                })
            },
            changeCategory(){
                this.category_id = this.categories[this.category_index].id
                this.fetch('diagnose')
            },
            go_detail(item){
                this.$router.push({
                    name:"diagnose-detail",
                    params:{id:item.id},
                })
            }
        },
        created() {
            this.fetch('category')
            this.fetch('diagnose')
            Interface.getShareInfo(this,"诊断送检——博医同行","","帮助战友获得全面诊疗意见和治疗安排")
            sessionStorage.removeItem("search_data")
            Interface.footPrint(22,1,0,"浏览博医同行诊断送检")
        }
    }
</script>

<style lang="scss">
    @import "./index.scss";
</style>



// WEBPACK FOOTER //
// src/views/diagnose/list/index.vue